import Axios from 'axios'
import { axiosConfig } from '../context/AxiosContext'

const axios = Axios.create(axiosConfig)

export default axios
